module.exports = __webpack_public_path__ + "static/media/robot-vs-human.0ae11dd8.jpg";